import Breadcrumb from "components/Common/Breadcrumb2"
import { objectToQueryString } from "helpers"
import useIsDarkTheme from "hooks/useIsDarkTheme"
import moment from "moment"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { withTranslation } from "react-i18next"
import Select from "react-select"
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Container,
  Form,
  FormGroup,
  FormText,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
  Table,
} from "reactstrap"
import { updateStatus } from "services/orders/calls"
import { badgesClass, courierClass, statusSafraOptions } from "./constants"
import { getGestao, getOrderOptions } from "services/orders/tracking/calls"

const Status = props => {
  document.title = "Status | Sensetek"

  const limit = 50

  const [isLoading, setIsLoading] = useState(false)
  const [hasError, setError] = useState(false)
  const [couriers, setCouriers] = useState([])
  const [query, setQuery] = useState({
    refKey: "",
    statusSafra: "",
    startAt: moment().subtract(30, "d").toDate(),
    endAt: new Date(),
    courierId: "",
  })
  const [currentPage, setCurrentPage] = useState(1)
  const [orders, setOrders] = useState([])
  const [total, setTotal] = useState(0)
  const [statues, setStatuses] = useState([])
  const [pages, setPages] = useState(1)
  const [isFirstPage, setIsFirstPage] = useState(true)
  const [isLastPage, setIsLastPage] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [confirm, setConfirm] = useState({})
  const [newErro, setNewErro] = useState(false)
  const [newErroMessage, setNewErroMessage] = useState("")
  const [newSucess, setNewSucess] = useState(false)
  const [newStatus, setNewStatus] = useState(null)
  const [stateClient, setStateClient] = useState([])

  const isDarkTheme = useIsDarkTheme()

  const [totalPages, setTotalPages] = useState(1)

  const [totalRecords, setTotalRecords] = useState(0)

  const paginationOptions = {
    custom: true,
    page: currentPage,
    sizePerPage: limit,
    totalSize: totalRecords,
    onPageChange: async (page, sizePerPage) => {
      setCurrentPage(page)
      setIsLoading(true)
      try {
        const {
          orders,
          total,
          pagination: { totalPages },
        } = await getGestao(query, page, limit)
        setOrders(orders)
        setTotalRecords(total)
        setTotalPages(totalPages)
      } catch (error) {
        console.error(error)
      } finally {
        setIsLoading(false)
      }
    },
    showTotal: true,
    hideSizePerPage: false,
    prePageTitle: "Anterior",
    nextPageTitle: "Próxima",
    lastPageTitle: "Última Página",
    firstPageTitle: "Primeira Página",
    paginationTotalRenderer: (from, to, size) => (
      <span>
        Exibindo {from} a {to} de {size} registros. {totalPages} páginas.
      </span>
    ),
  }

  const courierOptions = couriers.map(courier => ({
    value: courier.id,
    label: courier.name,
  }))

  const stateClientOptions = stateClient.map(stateClient => ({
    value: stateClient.id,
    label: stateClient.name,
  }))

  const selectRow = {
    mode: "checkbox",
    hideSelectColumn: true,
  }

  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]

  const columns = [
    {
      dataField: "shippingOrderCode",
      isDummyField: true,
      text: "AR Mestre",
      sort: false,
      formatter: (cellContent, row) => (
        <b>
          {row?.shippingOrderCode
            ? row?.shippingOrderCode
            : row?.shippingTrackerCode}
        </b>
      ),
    },
    {
      dataField: "shippingCompany.name",
      text: "Transportadora",
      sort: false,
      headerAlign: "center",
      align: "center",
      formatter: (cellContent, row, rowIndex, formatExtraData) => {
        return (
          <span
            className={`badge ${courierClass[row.shippingCompany.id]} ${
              isDarkTheme ? "bg-soft" : ""
            }`}
          >
            {cellContent}
          </span>
        )
      },
      formatExtraData: {
        darkTheme: isDarkTheme,
      },
    },
    {
      dataField: "currentStatus.name",
      text: "Situação Atual",
      sort: false,
      headerAlign: "center",
      align: "center",
      formatter: (cellContent, row, rowIndex, formatExtraData) => {
        return (
          <span
            className={`badge ${badgesClass[row.currentStatus?.id]} ${
              isDarkTheme ? "bg-soft" : ""
            }`}
          >
            {cellContent}
          </span>
        )
      },
      formatExtraData: {
        darkTheme: isDarkTheme,
      },
    },
  ]

  const onQuery = e => {
    e.preventDefault()
    setIsLoading(true)
    fetchOrders(query)
  }

  const fetchFilters = async () => {
    try {
      const { statuses, couriers, statusesClient } = await getOrderOptions()
      setStatuses(statuses)
      setCouriers(couriers)
      setStateClient(statusesClient)
    } catch (error) {
      console.error(error)
    }
  }

  const fetchOrders = async (filters, page = 1) => {
    setError(false)
    try {
      const {
        orders,
        total,
        pagination: { totalPages },
      } = await getGestao(filters || query, page, limit)
      setOrders(orders)
      setCurrentPage(1)
      setTotalRecords(total)
      setTotalPages(totalPages)
    } catch (err) {
      setError(err)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    setIsLoading(true)
    fetchFilters()
    fetchOrders()
  }, [])

  const courierHandleChange = options => {
    let lista = options ? options.map(items => items.value) : []
    setQuery({
      ...query,
      courierId: lista.toString(),
    })
  }

  const statusSafraHandleChange = options => {
    let lista = options ? options.map(items => items.value) : []
    setQuery({
      ...query,
      statusSafra: lista.toString(),
    })
  }

  const handleNewStatus = options => {
    setNewErro(false)
    setNewStatus(options)
  }

  const handleUpdateStatus = async () => {
    try {
      const res = await updateStatus(orders, newStatus, query)
      setIsLoading(true)
      fetchOrders(query)
      setNewSucess(true)
      setNewErro(false)
    } catch (error) {
      setNewErro(true)
      setNewErroMessage("Problema ao atualizar os status")
    }
  }

  const handleClickOpen = () => {
    if (!newStatus) {
      setNewErro(true)
      setNewErroMessage("Obrigatório selecionar o status")
      return
    }
    setNewErro(false)
    setConfirm({
      title: "Confirmação",
      body: (
        <div>
          <p>
            Esta ação vai atualizar o status para todos os casos selecionados,
            deseja mesmo confirmar esta ação?
          </p>
        </div>
      ),
      onConfirm: () => {
        handleUpdateStatus()
        setShowModal(false)
        setNewStatus(null)
      },
    })
    setShowConfirm(true)
  }

  const onTableChange = (type, newState) => {}

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title={props.t("Configurações")}
            breadcrumbItems={[{ title: props.t("Status"), path: "#" }]}
          />
          <Row>
            <Card>
              <CardHeader tag={"h4"} className="bg-primary text-white">
                Gestão de Status
              </CardHeader>
              <CardBody>
                <Form className="form-horizontal" onSubmit={onQuery}>
                  <Row>
                    <Col lg={3} md={6}>
                      <FormGroup controlid="orderKeyRef">
                        <Label>Chave</Label>
                        <div className="col-md-12">
                          <Input
                            type="textarea"
                            maxLength="1500"
                            rows="6"
                            value={query.refKey}
                            onChange={e => {
                              setQuery({
                                ...query,
                                refKey: e.target.value,
                              })
                            }}
                          />
                        </div>
                        <FormText className="text-muted">
                          Chave: Contrato, AR Mestre{" "}
                          <b>(Máximo de 100 linhas)</b>
                        </FormText>
                      </FormGroup>
                    </Col>
                    <Col lg={9} md={6}>
                      <Row>
                        <Col lg={4}>
                          <Label>Tipo de Data</Label>
                          <select
                            className="form-select"
                            value={String(query.dateFilter)}
                            onChange={e => {
                              setQuery({
                                ...query,
                                dateFilter: e.target.value,
                              })
                            }}
                          >
                            <option value="emittedAt">
                              Movimento (Default)
                            </option>
                            <option value="shippingPostedAt">Expedição</option>
                            <option value="orderedWebAt">Pedido FVS</option>
                          </select>
                        </Col>
                        <Col lg={4}>
                          <FormGroup controlid="ordersStartDateRef">
                            <Label>Início</Label>
                            <DatePicker
                              className="form-control"
                              dateFormat="dd/MM/yyyy"
                              selected={query.startAt}
                              selectsStart
                              startDate={query.startAt}
                              endDate={query.endAt}
                              onChange={e => {
                                setQuery({
                                  ...query,
                                  startAt: e,
                                })
                              }}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg={4}>
                          <FormGroup controlid="ordersEndDateRef">
                            <Label>Fim</Label>
                            <DatePicker
                              className="form-control"
                              dateFormat="dd/MM/yyyy"
                              selected={query.endAt}
                              selectsEnd
                              startDate={query.startAt}
                              endDate={query.endAt}
                              onChange={e => {
                                setQuery({
                                  ...query,
                                  endAt: e,
                                })
                              }}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={6}>
                          <FormGroup controlid="ordersStatusRef">
                            <Label>St Visão Safra</Label>
                            <Select
                              classNamePrefix="reactSelect"
                              isMulti
                              options={statusSafraOptions}
                              maxMenuHeight={150}
                              onChange={statusSafraHandleChange}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg={6}>
                          <FormGroup controlid="ordersStatusRef">
                            <Label>Transportadora</Label>
                            <Select
                              classNamePrefix="reactSelect"
                              isMulti
                              options={courierOptions}
                              maxMenuHeight={150}
                              onChange={courierHandleChange}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <div
                    className="d-flex flex-row-reverse vstack gap-2"
                    style={{
                      display: "flex",
                      alignItems: "flex-end",
                    }}
                  >
                    <button className="btn btn-primary btn-block" type="submit">
                      Filtrar
                    </button>
                    {!isLoading && orders.length !== 0 && (
                      <button
                        className="btn btn-info btn-block"
                        onClick={e => {
                          e.preventDefault()
                          setShowModal(true)
                        }}
                      >
                        Alterar
                      </button>
                    )}
                  </div>
                </Form>
                <hr className="mt-1" />
                {!isLoading && (
                  <div className="accordion-body">
                    {orders.length > 0 && (
                      <PaginationProvider
                        pagination={paginationFactory(paginationOptions)}
                      >
                        {({ paginationTableProps, paginationProps }) => (
                          <ToolkitProvider
                            keyField="id"
                            columns={columns}
                            data={orders}
                          >
                            {toolkitProps => (
                              <React.Fragment>
                                <Row>
                                  <Col>
                                    <PaginationListStandalone
                                      {...paginationProps}
                                    />
                                  </Col>
                                </Row>
                                <Row>
                                  <Col xl="12">
                                    <div className="table-responsive">
                                      <BootstrapTable
                                        responsive
                                        bordered
                                        striped
                                        remote={{
                                          filter: false,
                                          pagination: true,
                                          sort: false,
                                          cellEdit: false,
                                        }}
                                        onTableChange={onTableChange}
                                        classes={
                                          "table align-middle table-nowrap"
                                        }
                                        headerWrapperClasses={"thead-light"}
                                        {...toolkitProps.baseProps}
                                        {...paginationTableProps}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                                <PaginationTotalStandalone
                                  {...paginationProps}
                                />
                              </React.Fragment>
                            )}
                          </ToolkitProvider>
                        )}
                      </PaginationProvider>
                    )}
                    {orders.length === 0 && (
                      <div style={{ textAlign: "center" }}>
                        <h5>Nenhum dado foi encontrado.</h5>
                      </div>
                    )}
                  </div>
                )}
                {isLoading && (
                  <div
                    className="accordion-body"
                    style={{ textAlign: "center" }}
                  >
                    <Spinner className="ms-2" color="primary" />
                  </div>
                )}
              </CardBody>
            </Card>
          </Row>
        </Container>
      </div>
      <Modal
        isOpen={showModal}
        toggle={() => {
          setShowModal(!showModal)
        }}
        centered
        size="xl"
        scrollable
      >
        <ModalHeader className="pt-3 pb-0">
          <p>Gerenciador de status</p>
          <button
            type="button"
            onClick={() => {
              setShowModal(false)
              {
                confirm
              }
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </ModalHeader>
        <ModalBody>
          <div style={{ fontSize: 15 }}>
            {newErro && <Alert severity="error">{newErroMessage}</Alert>}
            {newSucess && (
              <Alert severity="success">
                Operação realizada com sucesso! Status alterados.
              </Alert>
            )}
            <Alert severity="warning">
              O limite de alterações por pesquisa é de {limit}!
            </Alert>
            <Label>Selecione o novo Status</Label>
            <Select
              classNamePrefix="reactSelect"
              options={stateClientOptions}
              placeholder="Status novo (obrigatorio)"
              onChange={handleNewStatus}
            />
            &nbsp; &nbsp; &nbsp; &nbsp;
            <Table striped>
              <thead className="thead-light">
                <tr>
                  <th scope="col">AR Mestre</th>
                  <th scope="col" className="text-center">
                    Status Atual
                  </th>
                  <th scope="col" className="text-center">
                    Status Novo
                  </th>
                </tr>
              </thead>
              <tbody>
                {orders?.map(order => (
                  <tr key={"file-" + order.id}>
                    <td>
                      {order?.shippingOrderCode
                        ? order?.shippingOrderCode
                        : order?.shippingTrackerCode}
                    </td>
                    <td className="text-center">{order.currentStatus?.name}</td>
                    <td className="text-center">
                      {newStatus ? newStatus?.label : ""}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            data-dismiss="modal"
            onClick={handleClickOpen}
          >
            Atualizar
          </Button>
          <Button
            color="secondary"
            data-dismiss="modal"
            onClick={() => {
              setShowModal(false)
              setNewStatus(null)
            }}
          >
            {props.t("Cancelar")}
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={showConfirm}
        toggle={() => {
          setShowConfirm(!showConfirm)
        }}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            <p>{confirm?.title}</p>
          </h5>
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
              {
                confirm
              }
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">{confirm?.body}</div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
            }}
            className="btn btn-secondary"
            data-dismiss="modal"
          >
            {props.t("Cancelar")}
          </button>
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
              confirm?.onConfirm()
            }}
            className="btn btn-primary"
            data-dismiss="modal"
          >
            {props.t("Confirmar")}
          </button>
        </div>
      </Modal>
    </React.Fragment>
  )
}

Status.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(Status)
